import styled from 'styled-components'
import { ContentWrapper } from '../Banner/Banner.css'

export const CompanySearchResultWrapper = styled.div`
    font-size: 14px;
    /* background-color: #fff;
    border-radius: 6px;
    padding: 32px; */
    @media (max-width: 768px) {
        margin-bottom: 24px;
    }
    ${ContentWrapper} {
        h2 {
            margin-bottom: 8px;
        }
    }
`

export const Keyword = styled.span`
    color: #000;
    font-weight: 700;
`

export const NoResultWrapper = styled.div`
    background-color: #f6f8fb;
    border-radius: 6px;
    padding: 20px 44px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-content: center;
    p {
        margin: 16px 0 0 0;
        color: #777;
        font-size:  14px;
        line-height: 22px;
        text-align: center;
    }
`

export const KeywordCount = styled.span`
    color: #ff7d55;
    font-weight: 700;
`

export const SearchDescription = styled.p`
    font-size: 14px;
    color: #000;
    @media (max-width: 768px) {
        padding: 0 16px;
    }
`

export const CompanySearchResultList = styled.div`
    /* @media (max-width: 768px) {
        padding: 16px;
        padding-bottom: 0;
    } */
`

export const CompanySearchResultListLoading = styled.div`
    > div {
        margin-bottom: 8px;
    }
`

export const ViewMoreButtonWrapper = styled.div`
    text-align: center;
    padding-top: 16px;
    @media (max-width: 768px) {
        padding: 16px;
    }
`

export const ClearKeyword = styled.p`
    color: #005AFF !important;
    cursor: pointer;
`
